import moment from 'moment';
import InExcludedDirections from '../../utils/checkInExcludedDirections';
import DEPART_DIC from '../../constants/DepartDic';
import { TOUR_ROW_MAP } from '../../constants/TourRowMap';
import { MEAL_TITLES } from '../../constants/MealTitles';
import {
  CREDIT_PERCENT,
  CURRENCY_CLASSES,
  DEFAULT_CURRENCY_CLASS,
} from '../../constants/CurrencyClasses';
import formatNumber from '../../utils/formatNumber';
import TOUR_LINK_KEYS from '../../constants/OneTour';

const composeOneTour = (
  item,
  filteredOperators = [],
  departure,
  request_model
) => {
  if (
    InExcludedDirections(
      item.operatorcode,
      item.departurecode,
      item.countrycode,
      item.regioncode
    )
  ) {
    return;
  }
  if (filteredOperators.includes(item.operatorcode)) {
    return;
  }
  const depart_id = departure;
  const depart_name = DEPART_DIC[departure]?.name;
  const row = {
    provider: 'tourvisor',
    request_id: '',
    source_id: '',
    hash: '',
    currency_class: 'rouble',
    base_tour: 1,
    depart_id: depart_id,
    depart_name: depart_name,
  };
  Object.entries(item).forEach(([key, value]) => {
    const new_key = TOUR_ROW_MAP[key] || key;
    row[new_key] = value || '';
  });

  row.offer_id = item.tours.tour[0].tourid;
  row.place_id = item.tours.tour[0].placement;
  row.place_name = item.tours.tour[0].placement;
  row.room_id = item.tours.tour[0].room;
  row.room_name = item.tours.tour[0].room;
  row.oper_id = item.tours.tour[0].operatorcode;
  row.oper_name = item.tours.tour[0].operatorname;
  row.price = parseInt(item.price, 10);
  row.hot_price = 0;
  row.child = row.child == '' ? 0 : row.child;
  row.ages = '';
  if (parseInt(row.adult, 10) == 2 && parseInt(row.child, 10) == 0) {
    row.show_half = true;
    row.hot_price = Math.ceil(row.price / 2);
  }
  if (item.tours.tour[0].mealcode === 9067) {
    row.meal_full = 'По программе экскурсионного тура';
  } else {
    row.meal_full = MEAL_TITLES[item.tours.tour[0].meal] || '';
  }
  row.meal_id = item.tours.tour[0].mealcode;
  row.meal_name = item.tours.tour[0].meal;
  row.star_name = row.star_id + '*';
  row.dt1 = item.tours.tour.length ? item.tours.tour[0].flydate : '25.04.2024';
  row.nights = item.tours.tour[0].nights;
  row.dt2 = moment(row.dt1, 'DD.MM.YYYY')
    .add(parseInt(item.tours.tour[0].nights, 10), 'days')
    .format('DD.MM.YYYY');

  row.volatility = '';
  row.hotel_link = row.hotel_link;
  row.currency_class =
    CURRENCY_CLASSES[item.currency] || DEFAULT_CURRENCY_CLASS;
  row.text = '';
  row.discount = false;

  row.comment = ''; //FindTourComment(item);

  row.full_price = row.price;
  row.credit_price = Math.round(row.full_price * CREDIT_PERCENT, 2);
  row.full_price_label = formatNumber(row.full_price);
  row.hot_price_label = formatNumber(row.hot_price);
  row.credit_price_label = formatNumber(row.credit_price);
  row.claim_mark = 'agency'; //(!!window.CLAIM_MARK) ? CLAIM_MARK : 'customer';
  row.credit = false;

  row.promo = /promo|промо/i.test(item.tours.tour[0].tourname) ? 1 : 0;
  if (row.claim_mark == 'small_credit') {
    row.credit = true;
  }
  row.hotel_adult = item.tours.tour[0].adults;
  row.hotel_child = item.tours.tour[0].child;
  row.adult = request_model['adults'];
  row.child = request_model['child'];
  row.ages = Array.isArray(request_model['ages'])
    ? request_model['ages'].join(',')
    : '';
  const filteredRow = Object.fromEntries(
    Object.entries(row).filter(([key]) => TOUR_LINK_KEYS.includes(key))
  );
  return {
    row: row,
    tour_link: new URLSearchParams(filteredRow).toString(),
    request_id: '',
    additional: '',
  };
};

export default composeOneTour;
